import { recordLinkV2 } from 'utilities/tagging'
import { CONTRATOS_DETAIL_PROCESS, FIOC_MODAL_ACTION_EVENT, FIOC_DOCUMENT_ID_MODAL_ACTION_EVENT } from 'constants/tagging'

const COMPONENT_FIOC = `modal/${FIOC_MODAL_ACTION_EVENT}`
const COMPONENT_DOCUMENT = `modal/${FIOC_DOCUMENT_ID_MODAL_ACTION_EVENT}`

const getEventValues = (isDocumentRequired) => {
    return {
        categoriaEvento: CONTRATOS_DETAIL_PROCESS,
        accionEvento: isDocumentRequired
            ? FIOC_DOCUMENT_ID_MODAL_ACTION_EVENT
            : FIOC_MODAL_ACTION_EVENT,
        component: isDocumentRequired
            ? COMPONENT_DOCUMENT
            : COMPONENT_FIOC
    }
}

export const taggingOpenEvent = (isDocumentRequired) => {
    const eventValues = getEventValues(isDocumentRequired)
    recordLinkV2({
        ...eventValues,
        etiquetaEvento: 'open',
        action: "open",
        format: "modal",
        element: "full"
    })
}

export const taggingCloseEvent = (isDocumentRequired) => {
    const eventValues = getEventValues(isDocumentRequired)
    recordLinkV2({
        etiquetaEvento: 'close',
        ...eventValues,
        action: "close",
        format: "cross",
        element: "close"
    })
}

export const taggingCancelEvent = (isDocumentRequired) => {
    const eventValues = getEventValues(isDocumentRequired)
    recordLinkV2({
        etiquetaEvento: 'cancel',
        ...eventValues,
        action: "cancel",
        format: "link",
        element: "cancel"
    })
}

export const taggingUpdateEvent = (isDocumentRequired) => {
    const eventValues = getEventValues(isDocumentRequired)
    recordLinkV2({
        etiquetaEvento: 'updateNow',
        ...eventValues,
        action: "click",
        format: "button",
        element: "updateNow"
    })
}
